export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ../~/rc-pagination/es/index.js
// module id = 2683
// module chunks = 1